import { useFormikContext } from "formik";
import React, { useState } from "react";
import Col from "react-bootstrap/esm/Col";
import Row from "react-bootstrap/esm/Row";
import Button from "react-bootstrap/esm/Button";
import { Link } from "react-router-dom";

import { FaEye } from "react-icons/fa";
import { FaEyeSlash } from "react-icons/fa";
import { IconContext } from "react-icons/lib";

export const SignInSubmission = ({ props }) => {
    const { isSubmitting, status } = useFormikContext(); // use to disable button while the request is being made to server and to check for successful api call

    const { showPassword, setShowPassword } = props

    let statusMessage = "";

    if (status?.error === true) {
        statusMessage = <p role="status" className="text-danger">Error signing-in.</p>;
    } else if (status?.error === false) {
        statusMessage = <p role="status" className="text-success">Successfully signed-in!</p>;
    } else {
        statusMessage = "";
    }

    return (
        <>
            
            <Row>
                <Col xs={3} className="d-flex justify-content-start">
                    <Button
                        className="btn btn-primary"
                        type="submit"
                        disabled={isSubmitting}
                        aria-label="Click to sign in."
                        aria-invalid={status?.error === true ? "true" : null}
                    >
                        Sign in
                    </Button>
                </Col>
                <Col
                    aria-hidden="true"
                    className="d-flex justify-content-end">
                    <Button
                        id="check"
                        aria-label="Show/Hide Password"
                        style={{ backgroundColor: "white", outline: "none" }}
                        onClick={() =>
                            props.setShowPassword((prev) => !prev)
                        }>
                        <IconContext.Provider
                            value={{ color: "blue", size: '20px' }}>
                            {showPassword ?
                                <FaEyeSlash />
                                :
                                <FaEye />
                            }
                        </IconContext.Provider>
                    </Button>
                </Col>
            </Row>
            <Row>{statusMessage}</Row>

            <Row className="mt-2">
                <Col xs={12} className="d-flex justify-content-end mb-1">
                    <Link 
                        to="/forgotPassword"
                        aria-label="Forgot Password, click to go to forgotten password page"
                    >
                        Forgot Password?
                    </Link>
                </Col>
                <Col xs={12} className="d-flex justify-content-end mb-1">
                    <span aria-hidden="true">
                        New to NN Apply Portal?&nbsp;
                    </span>
                    <Link 
                        to="/signup"
                        aria-label="Sign Up, click to go to sign up page"
                    >
                        Sign up
                    </Link>
                </Col>
                <Col xs={12} className="d-flex justify-content-end mb-1">
                    <span aria-hidden="true">
                        First time signing in?&nbsp;
                    </span>
                    <Link
                        to="/request-account-verification"
                        className="text-end"
                        aria-label="Request email verification, click to go email verification page."
                    >
                        Verify your email here
                    </Link>
                </Col>
            </Row>
        </>
    );
};
